export default __webpack_public_path__ + "1d1caae390e0175fb75fd4112dab85d0.ttf";